import type { WorkspaceModule } from '@/features/workspace/types';

export type RoleModuleTheme = {
  accents: string[];
  title: string;
  subtitle: string;
  cta: string;
  className: string;
};

/** Distinct 1.83-style card themes per workspace cabinet (Task 14 §4). */
export const ROLE_MODULE_THEMES = {
  advisor: {
    accents: ['#49ddb7', '#41d2ff', '#5da8ff', '#e2ad3a', '#9e80ff', '#66b7e8', '#ff7a64', '#2ea8df'],
    title: 'Рабочий кабинет эдвайзера',
    subtitle: 'Докторанты, мониторинг, планы, аттестация и сопровождение',
    cta: 'Открыть маршрут →',
    className: 'role-module-grid--advisor',
  },
  supervisor: {
    accents: ['#9e80ff', '#66b7e8', '#41d2ff', '#49ddb7', '#e2ad3a', '#ff7a64', '#5da8ff', '#2ea8df'],
    title: 'Кабинет научного руководителя',
    subtitle: 'Супервизия, модерация, заявки и совместные проекты',
    cta: 'Открыть супервизию →',
    className: 'role-module-grid--supervisor',
  },
  researcher: {
    accents: ['#41d2ff', '#2ea8df', '#49ddb7', '#5da8ff', '#e2ad3a', '#9e80ff', '#66b7e8', '#ff7a64'],
    title: 'Исследовательский кабинет',
    subtitle: 'Профиль, публикации, гранты, рукописи и инструменты',
    cta: 'Открыть модуль →',
    className: 'role-module-grid--researcher',
  },
  operations: {
    accents: ['#ff7a64', '#e2ad3a', '#41d2ff', '#49ddb7', '#9e80ff', '#5da8ff', '#66b7e8'],
    title: 'Операционный кабинет партнёра',
    subtitle: 'Заявки, доступы, документы, уведомления и сервисы',
    cta: 'Открыть очередь →',
    className: 'role-module-grid--operations',
  },
  partner: {
    accents: ['#49ddb7', '#41d2ff', '#9e80ff', '#e2ad3a', '#ff7a64', '#66b7e8'],
    title: 'Кабинет научного партнёра',
    subtitle: 'Заявки, проекты, опросы, заказы и академические связи',
    cta: 'Открыть карточку →',
    className: 'role-module-grid--partner',
  },
  teacher: {
    accents: ['#5da8ff', '#49ddb7', '#e2ad3a', '#9e80ff', '#41d2ff', '#ff7a64', '#66b7e8', '#2ea8df'],
    title: 'Кабинет преподавателя',
    subtitle: 'Учебный процесс, журнал, проекты и обращения обучающихся',
    cta: 'Открыть раздел →',
    className: 'role-module-grid--teacher',
  },
  doctoral: {
    accents: ['#9e80ff', '#49ddb7', '#41d2ff', '#e2ad3a', '#ff7a64', '#66b7e8'],
    title: 'Кабинет докторанта',
    subtitle: 'Учебный процесс, диссертация, публикации и научный руководитель',
    cta: 'Открыть процесс →',
    className: 'role-module-grid--doctoral',
  },
  author: {
    accents: ['#e2ad3a', '#ff7a64', '#41d2ff', '#9e80ff', '#49ddb7'],
    title: 'Кабинет автора / соавтора',
    subtitle: 'Заявки, опросы, связи, календарь и исследовательские инструменты',
    cta: 'Открыть кабинет →',
    className: 'role-module-grid--author',
  },
  client: {
    accents: ['#41d2ff', '#49ddb7', '#e2ad3a', '#9e80ff', '#ff7a64', '#66b7e8', '#5da8ff'],
    title: 'Кабинет клиента',
    subtitle: 'Заявки, проекты, календарь, связи и файлы',
    cta: 'Открыть сервис →',
    className: 'role-module-grid--client',
  },
  editor: {
    accents: ['#ff7a64', '#9e80ff', '#41d2ff', '#e2ad3a', '#49ddb7'],
    title: 'Кабинет редактора проекта',
    subtitle: 'Заявки, документы, связи, статистика и файлы',
    cta: 'Открыть редакцию →',
    className: 'role-module-grid--editor',
  },
} as const satisfies Record<string, RoleModuleTheme>;

export type RoleModuleThemeKey = keyof typeof ROLE_MODULE_THEMES;

/** Keep type import available for callers that map modules + theme together. */
export type RoleModuleGridModules = WorkspaceModule[];
